export const RecruitmentTag: React.FC<{
  tag: {id: number; name: string};
}> = ({tag}) => {
  return (
    <p className={'bg-black-3 text-xs text-white py-2 px-8 text-center mr-8'}>
      {tag.name}
    </p>
  );
};
